import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent } from 'vue';

import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import { useCampaignInfo } from '@/features/sponsored-recommendations/composables/useSendBidId';

interface CampaignInfoProps {
	sponsoredCampaign: NonNullable<SponsoredAdFragment['campaign']>;
	lazy: boolean;
	hidePromotionalText?: boolean;
	hideRating?: boolean;
	isTitleSizeFixed?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignInfo',
  props: {
    sponsoredCampaign: null,
    lazy: { type: Boolean, default: true },
    hidePromotionalText: { type: Boolean, default: false },
    hideRating: { type: Boolean, default: false },
    isTitleSizeFixed: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { sponsoredCampaign: NonNullable<SponsoredAdFragment['campaign']>, lazy: boolean, hidePromotionalText: boolean, hideRating: boolean, isTitleSizeFixed: boolean };



const TitleScoreList = defineAsyncComponent(() => import('@/components/TitleScoreList.vue'));

const { campaignNode, promotionalTitle, promotionalText, hasDisclaimerText } = useCampaignInfo(
	() => props.sponsoredCampaign
);

const getTitleSize = computed<'regular' | 'medium' | 'small'>(() => {
	if (props.isTitleSizeFixed) {
		return 'regular';
	}

	const titleLength = promotionalTitle.value?.length ?? 0;

	if (titleLength >= 22 && titleLength < 32) return 'medium';

	if (titleLength >= 32) return 'small';

	return 'regular';
});

// Hacks & Exceptions
/** Campaigns with a light colored background that need darker text. */
const highContrastCampaigns = ['TWIXMAS_BURST2_GB_SRA'];
const isHighContrast = computed(() => highContrastCampaigns.includes(props.sponsoredCampaign.name));

return { __sfc: true,props, TitleScoreList, campaignNode, promotionalTitle, promotionalText, hasDisclaimerText, getTitleSize, highContrastCampaigns, isHighContrast }
}

})